import { systemManagementListDetailService } from '@services/private/system/management/management-list-detail.service';
import { generateQueryString } from '../strings/shared-helpers-strings';
import { is200xRange } from '@utils/utilities';
import { updateState } from '../update-state';

type ListData = {
  page: number;
  size: number;
  sortName: string;
  sortType: string;
  admSchGroup: string;
  schKeyword: string;
  schAdmSt: '10' | '20' | '30' | '50' | '';
  admList:
    | [
        {
          admEmail: string;
          admId: string;
          admName: string;
          admSeq: string;
          admSt: string;
          regDt: string;
        },
      ]
    | [];
  totalCount: number;
};

export const getSystemManagementList = async (
  listData: ListData,
  payload = [],
  stateSetter,
  fields,
) => {
  const { page, size, sortName, sortType, admSchGroup, schKeyword, schAdmSt } =
    listData;

  const queryString = generateQueryString(
    [
      { key: 'page', value: page },
      { key: 'size', value: size },
      { key: 'sortName', value: sortName },
      { key: 'sortType', value: sortType },
      { key: 'admSchGroup', value: admSchGroup },
      { key: 'schKeyword', value: schKeyword },
      { key: 'schAdmSt', value: schAdmSt },
    ].map((item) => {
      return fields.includes(item.key)
        ? payload.find((field) => {
            // @ts-ignore
            return field.key === item.key;
          })
        : item;
    }),
  );

  const { response, statusCode } =
    await systemManagementListDetailService(queryString);

  if (response?.code === '1' && is200xRange(statusCode)) {
    const list = [
      { key: 'admList', value: response?.result?.admListInfo?.admList },
      {
        key: 'totalCount',
        value: response?.result?.admListInfo?.totalCount,
      },
    ];

    payload.forEach((item) => {
      list.push(item);
    });

    updateState(list, stateSetter);
  }
};
